/**
 * File: gh_partner.js
 *
 * Minimal, do-no-harm updates:
 * 1) Same-origin app proxy call using relative URL (keeps request on blushington.com).
 * 2) No custom headers (avoids preflight).
 * 3) Defensive handling to prevent JSON.parse from crashing when the response is empty,
 *    HTML, or a blocked/redirected request.
 *
 * NOTE: This does NOT "fix" the redirect/CORS by itself. The server MUST stop returning
 * a redirect to mainwp.redthinkingllc.com and instead return 200 + JSON.
 */

var simpatico_monitor = true;
var partnerReferralLink = "";
var blush_partnerID = "";
var partnerQueryString = "";
var arr_pids = [];
var meet_shop = "MEET";

jQuery(document).ready(function () {
  var partnerTitleVariable = jQuery("#\\#_gh_variable_partner_title").text();
  var partnerNameVariable = jQuery("#\\#_gh_variable_partner_name").text();
  var partnerBioVariable = jQuery("#\\#_gh_variable_partner_bio").text();
  var partnerPictureVariable = jQuery("#\\#_gh_variable_partner_picture").text();
  var partnerReferralLink = jQuery("#\\#_gh_variable_partner_referral_link").text();
  var partnerID = jQuery("#\\#_gh_variable_partner_id").text();
  var sealImage = "";
  var partnerBioHeaderText = "";

  jQuery("#partner_title").text(partnerTitleVariable);
  //jQuery('#gh_partner-name').text(partnerNameVariable);
  //jQuery('#gh_partner-img').attr("src",partnerPictureVariable);

  // Get GrowthHero Partner data via Shopify App Proxy (same-origin)
  var request = new XMLHttpRequest();
  request.open("GET", "/a/rt/gh_partner.php?sl=" + encodeURIComponent(partnerID));

  request.onreadystatechange = function () {
    if (this.readyState !== 4) return;

    // If the proxy handler is redirecting (301/302) or the browser blocks the follow-up (CORS),
    // status/responseText may be unusable for JSON parsing.
    if (!(this.status >= 200 && this.status < 300)) {
      if (simpatico_monitor && window.console && console.error) {
        console.error(
          "gh_partner proxy request failed:",
          "status=" + this.status,
          "responseText=" + (this.responseText || "").slice(0, 200)
        );
      }
      return;
    }

    var raw = this.responseText || "";
    var partner;

    try {
      partner = JSON.parse(raw);
    } catch (e) {
      if (simpatico_monitor && window.console && console.error) {
        console.error(
          "gh_partner JSON parse failed:",
          e && e.message ? e.message : e,
          "responseText(head)=" + raw.slice(0, 200)
        );
      }
      return;
    }

    //console.log('partner:', partner);
    if (partner["groupId"] == "8022") {
      meet_shop = "SHOP";
      //jQuery( ".shop_my" ).html("Our");
      //jQuery( ".shop_me" ).html("Us");
      if (
        typeof partner["additionalFields"] !== "undefined" &&
        typeof partner["additionalFields"]["website"] !== "undefined" &&
        partner["additionalFields"]["website"] != ""
      ) {
        jQuery("#blo-website-button a").attr("href", partner["additionalFields"]["website"]);
        jQuery("#blo-website-button a").html("BOOK AN APPOINTMENT AT " + partnerTitleVariable);
        jQuery("#blo-website-button").removeClass("hide");
        jQuery("#shop-collection-button-bottom").addClass("hide");
      }
    }

    setShopWithMeCookie(partnerID, partnerPictureVariable);

    partnerQueryString = "?ghref=" + partner["groupId"] + ":" + partnerID;

    jQuery("#partner_link").attr(
      "href",
      "/pages/" +
        partner["additionalFields"]["shortLink"] +
        "?ghref=" +
        partner["groupId"] +
        ":" +
        partnerID +
        "&ghmodalname=" +
        partner["firstName"] +
        "%20" +
        partner["lastName"]
    );
    jQuery("#partner_link").attr("data-link", partner["additionalFields"]["shortLink"]);

    jQuery("#_gh_partner_page").css("display", "block");
  };

  request.send();

  jQuery(".wishlistbodycontainer").on("click", ".product-form__submit", function () {
    //console.log("product-form__submit: true");
    //var vid = jQuery(this).data('variantid');

    if (partnerID != blush_partnerID) {
      //console.log("cookie doesnt match page");
      jQuery(".current-artist").text(blush_swm.full_name);
      jQuery(".new-artist").text(partnerNameVariable);
      jQuery("#new-artist").attr("data-id", partnerID);
      //jQuery(".shop-with-compare-text a").attr("data-variantid", vid);
      jQuery(".shop-with-compare").css("display", "block");
    } //else {
    //console.log("vid: "+ vid);
    //addItemToCart( this, vid, 1, "1", "","reload");
    //return false;
    //}
  });
});